export default "__VITE_ASSET__DgJirVw3__"